import { ResponsiveLayout } from "@bca/ui-library";
import React from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import styled from "styled-components";

import { MechanicalReportAnalytics } from "../analytics/MechanicalReportAnalytics";
import { batteryReportDataPush } from "../analytics/batteryReportDataPush";
import VehicleDetailsAnalytics from "../analytics/VehicleDetailsAnalytics.type";
import ConditionReport from "./ConditionReport";
import MechanicalReport from "./MechanicalReport";
import BatteryReport from "./BatteryReport";
import { ViewportSizeType } from "../hooks/useViewport.hook";
import {
  CategoryMapping,
  ReportUrls,
} from "../vehicle-search-details/vehicleSearch.type";
import { Items as VehicleInformationType } from "../vehicle-search-details/vehicleSearch.type";
import { SHOW_BATTERY_GRADE_SLIDEOUT } from "../redux/slices/appSlice";

interface KeyDecisionInfoProps {
  vehicleInformation: VehicleInformationType;
  owners?: string;
  grade?: string;
  batteryReport?: { batteryCondition: number; isApplicable: boolean };
  batteryReportLink?: ReportUrls;
  conditionReport?: { rel: string; href: string; type: string };
  mechanicalReport?: ReportUrls;
  vehicleAnalytics?: VehicleDetailsAnalytics;
  categoryMapping: CategoryMapping[] | undefined;
  viewport?: ViewportSizeType;
}

const StyledResponsiveLayout = styled(ResponsiveLayout)`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 0;
`;

const KeyDecisionInfo: React.FunctionComponent<KeyDecisionInfoProps> = ({
  grade,
  conditionReport,
  mechanicalReport,
  vehicleAnalytics,
  categoryMapping,
  viewport,
  batteryReport,
  batteryReportLink,
  vehicleInformation,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { catalogueRef } = router.query;

  const { type: reportType } =
    vehicleInformation?.reportUrls?.find(
      (report) => report.rel === "mechanicalreporturl"
    ) || {};

  const handleOpenBatteryGradeSlideout = () => {
    const mechReportCombo = MechanicalReportAnalytics({
      reportType,
      categoryMapping,
    });

    batteryReportDataPush({
      mechReportCombo,
      isTracked: vehicleInformation.isTracked,
      note: "",
      catalogueRef,
      vehicleInfo: vehicleInformation,
    });

    dispatch(
      SHOW_BATTERY_GRADE_SLIDEOUT({
        showBatteryGradeSlideout: true,
        batteryGradeSlideoutData: {
          batteryCondition: batteryReport.batteryCondition,
          reportUrl: batteryReportLink?.href,
          vehicleInformation,
        },
      })
    );
  };

  return (
    <StyledResponsiveLayout>
      {batteryReport?.isApplicable && (
        <BatteryReport
          condition={batteryReport.batteryCondition}
          onOpenReport={handleOpenBatteryGradeSlideout}
          viewport={viewport}
        />
      )}
      <ConditionReport
        grade={grade}
        anchorLink={conditionReport?.href}
        vehicleAnalytics={vehicleAnalytics}
        viewport={viewport}
      />
      <MechanicalReport
        reportType={mechanicalReport?.type}
        anchorLink={mechanicalReport?.href}
        vehicleAnalytics={vehicleAnalytics}
        categoryMapping={categoryMapping}
        viewport={viewport}
      />
    </StyledResponsiveLayout>
  );
};

export default KeyDecisionInfo;
